// extracted by mini-css-extract-plugin
module.exports = {"table":"PostedPaymentCard_table__3wcIH","info":"PostedPaymentCard_info__1FOof","breakText":"PostedPaymentCard_breakText__soXoh"};